import _isEmpty from 'lodash-es/isEmpty'
import sortBy from 'lodash-es/sortBy'

export const alphabeticallySortObjectsBasedOnKey = (obj, key) => {
  return sortBy(obj, key)
}

export function isEmpty(object) {
  return _isEmpty(object)
}
